module.exports = __webpack_public_path__ + "static/img/25.d723620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/25.png
// module id = 3ge6
// module chunks = 1